import get from 'lodash/get';

export const getSsoUserMemberId = (state) => get(state, 'authentication.ssoUser.memberId', null);
export const getSsoUserTitle = (state) => get(state, 'authentication.ssoUser.title', null);
export const getSsoUserFirstName = (state) => get(state, 'authentication.ssoUser.firstName', null);
export const getSsoUserLastName = (state) => get(state, 'authentication.ssoUser.lastName', null);
export const getSsoUserPointsBalance = (state) => get(state, 'authentication.ssoUser.pointsBalance', '0');
export const getSsoUserMembershipTier = (state) => get(state, 'authentication.ssoUser.membershipTier', null);
export const getSsoUserToken = (state) => get(state, 'authentication.ssoUser.token', null);
export const getSsoUserIsAuthenticated = (state) => get(state, 'authentication.ssoUser.isAuthenticated', false);
export const getSsoInitializationState = (state) => get(state, 'authentication.ssoUser.hasInitializedSSO', false);
